import { Divider } from "@mui/material";
import { FrontendUserInfo } from "node-library/dist/portal";

interface Props {
	label: string;
	icon: React.ReactNode;
	isExpanded: boolean;
	isMobile: boolean;
	selected: boolean;
	onClick: () => void;
}

export default function SidebarRow(props: Props) {
	return (
		<>
			{props.isMobile && !props.isExpanded ? (
				<> </>
			) : (
				<div
					className={`sidebar-action-row ${
						props.selected ? "sidebar-action-row-selected" : ""
					}`}
					onClick={props.onClick}
				>
					<div className={`sidebar-left-container`}>
						<div className={`sidebar-action-row-image-container`}>
							{props.icon}
						</div>
						<div
							className={`sidebar-action-row-text typography-body-01 ${
								props.selected ? "sidebar-action-text-selected" : "grey-text"
							} ${props.isExpanded ? `` : `sidebar-collapse-hide`}`}
						>
							{props.label}
						</div>
					</div>

					<Divider
						orientation="vertical"
						className={`${props.isExpanded ? `` : `sidebar-collapse-hide`}`}
						flexItem
						sx={{
							borderWidth: "1.5px",
							borderRadius: "1.5px",
							borderColor: props.selected ? "white" : "transparent",
						}}
					></Divider>
				</div>
			)}
		</>
	);
}
